import { NgxMatDatetimePickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { AdminConfig, AdminModule, AUTH_INTERCEPTOR, AuthHandler } from '@modeso/dgoods-lib-admin-fe';
import {
    DgoodsSharedModule,
    GetEnumKeyFromValuePipe,
    MarkdownPipe,
    ModesoCoreModule,
    PascalCasePipe,
    SafeHtmlPipe,
} from '@modeso/twint-lib-core-fe';
import { TwintCouponConfig, TwintCouponModule } from '@modeso/twint-lib-couponsmng-fe';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { MatTableExporterModule } from 'mat-table-exporter';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DgoodsUserConfig, DgoodsUserModule } from '../../../dgoods-lib-user-fe';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SessionOrchestrator } from './orchestrator/session.orchestrator';
import { ConfirmationDialogComponent } from './pages/Dialogs/confirmation-dialog.component';
import { DescriptionEditorDialog } from './pages/Dialogs/descriptionEditorDialog/descriptionEditorDialog';
import { ErrorDialogComponent } from './pages/Dialogs/error-dialog.component';
import { AuditLogsPage } from './pages/auditLogs/auditLogs.page';
import { BasePageComponent } from './pages/base.page';
import { BlockedProductsPage } from './pages/blockedProducts/blockedProducts.page';
import { ChangePasswordPage } from './pages/changePassword/changePassword.page';
import { ClosedUserGroupPage } from './pages/closedUserGroup/closedUserGroup.page';
import { UserSearchFormComponent } from './pages/closedUserGroup/userSearchForm/userSearchForm.page';
import { ContentBoxListComponent } from './pages/contentBoxesManagment/content-boxes-list/content-boxes-list.page';
import { CreateContentBoxComponent } from './pages/contentBoxesManagment/create-content-box/create-content-box.page';
import { ContentManagementPage } from './pages/contentManagement/contentManagement.page';
import { ContentPageListComponent } from './pages/contentPagesManagment/content-pages-list/content-pages-list.page';
import { CreateContentPageComponent } from './pages/contentPagesManagment/create-content-page/create-content-page.page';
import { AddCouponPage } from './pages/couponManagement/addCoupon/add-coupon.page';
import { CouponsPage } from './pages/couponManagement/coupons.page';
import { DigitalVoucherConfiguratorComponent } from './pages/digital-voucher-configurator/digital-voucher-configurator.component';
import { DropDownListConfiguratorComponent } from './pages/digital-voucher-configurator/drop-down-list-configurator/drop-down-list-configurator.component';
import { TextFormComponent } from './pages/digital-voucher-configurator/text-form/text-form.component';
import { AddOrUpdateIssuerDialog } from './pages/fraudLimits/addOrUpdateIssuerDialog/addOrUpdateIssuerDialog';
import { FraudLimitsPage } from './pages/fraudLimits/fraudLimits.page';
import { UpdateDefaultDialog } from './pages/fraudLimits/updateDialog/updateDefaultDialog';
import { CreateFraudRulePage } from './pages/fraudRules/create-fraud-rule/create-fraud-rule.page';
import { FraudRulesPage } from './pages/fraudRules/fraud-rules.page';
import { HomePage } from './pages/home/home.page';
import { LoginPage } from './pages/login/login.page';
import { ManageContentPage } from './pages/manageContent/manageContent.page';
import { UpdateLocalizationByKeyDialog } from './pages/manageContent/updatelocalizationByKeyDialog/updateLocalizationByKeyDialog';
import { ManageUsersPage } from './pages/manageUsers/manageUsers.page';
import { UpdateUserByIdDialog } from './pages/manageUsers/updateUserByIdDialog/updateUserByIdDialog';
import { CreateMerchantPage } from './pages/merchantManagement/createMerchant/create-merchant.page';
import { MerchantListPage } from './pages/merchantManagement/merchant-list/merchant-list.page';
import { CreateNewstickerPage } from './pages/newstickerManagment/create-newsticker/create-newsticker.page';
import { NewstickerListPage } from './pages/newstickerManagment/newsticker-list/newsticker-list.page';
import { OrderReportsPage } from './pages/ordersReports/order-reports.page';
import { PopUpComponent } from './pages/popUp/popUp';
import { EditCategoryDialogComponent } from './pages/productCategories/edit-category-dialog.component';
import { ProductCategoriesPage } from './pages/productCategories/productCategories.page';
import { ProductContentManagmentPage } from './pages/productContentManagement/productContentManagment.page';
import { UpdateContentByProductLineDialog } from './pages/productContentManagement/updateContentByProductLineDialog/updateContentByProductLineDialog';
import { ProductManagmentPage } from './pages/productManagment/productManagment.page';
import { SettingsEditDialogComponent } from './pages/productSettings/confirmation-dialog.component';
import { ProductSettingsPage } from './pages/productSettings/productSettings.page';
import { ReportsPage } from './pages/reports/reports.page';
import { SamlAssertPage } from './pages/samlAssert/samlAssert.page';
import { SignupPage } from './pages/signup/signup.page';
import { CreateSpotLightComponent } from './pages/spotlightManagement/create-spotlight/create-spot-light.component';
import { ListSpotLightsComponent } from './pages/spotlightManagement/list-spotlights/list-spotlights.component';
import { UserManagementPage } from './pages/userManagement/userManagement.page';
import { WhiteListingPage } from './pages/whiteListing/whiteListing.page';
import { AuthGuard } from './shared/auth.guard';
import { SafeHtmlPipeImages } from './shared/markdown/markdownWithImages/safeHtml.pipe';
import { DecimalNumber } from './shared/pipes/decimal-number.pipe';
import { SafeHtmlAllowUrlPipe } from './shared/pipes/safeHtmlAllowUrl.pipe';
import { SharedModule } from './shared/shared.module';
import { ContentAreaComponent } from './skeleton/content-area/content-area.component';
import { HeaderComponent } from './skeleton/header/header.component';
import { SidebarComponent } from './skeleton/sidebar/sidebar.component';
import { AnalyticsModule } from './state/analytics/analytics.module';
import * as fromAppState from './state/app.state.reducer';
import { CartModule } from './state/cart/cart.module';
import { ProductsModule } from './state/products/products.module';

const adminConfig: AdminConfig = { apiGateway: environment.modeso.apiGateway, serviceId: 'admin' };

const couponConfig: TwintCouponConfig = { apiGateway: environment.modeso.apiGateway, serviceId: 'cart' };

const userConfig: DgoodsUserConfig = { apiGateway: environment.modeso.apiGateway, serviceId: 'users' };

@NgModule({
    declarations: [
        AppComponent,
        BasePageComponent,
        HeaderComponent,
        SidebarComponent,
        ContentAreaComponent,
        HomePage,
        FraudLimitsPage,
        UpdateDefaultDialog,
        LoginPage,
        ChangePasswordPage,
        SignupPage,
        BlockedProductsPage,
        PopUpComponent,
        ReportsPage,
        OrderReportsPage,
        AddOrUpdateIssuerDialog,
        ManageContentPage,
        UpdateLocalizationByKeyDialog,
        WhiteListingPage,
        ProductSettingsPage,
        AddOrUpdateIssuerDialog,
        ProductManagmentPage,
        UpdateContentByProductLineDialog,
        ContentManagementPage,
        ProductContentManagmentPage,
        ProductCategoriesPage,
        UserManagementPage,
        ManageUsersPage,
        UpdateUserByIdDialog,
        ClosedUserGroupPage,
        UserSearchFormComponent,
        AuditLogsPage,
        SamlAssertPage,
        FraudRulesPage,
        CreateFraudRulePage,
        CreateMerchantPage,
        MerchantListPage,
        DigitalVoucherConfiguratorComponent,
        TextFormComponent,
        DropDownListConfiguratorComponent,
        AddCouponPage,
        CouponsPage,
        CreateNewstickerPage,
        NewstickerListPage,
        DescriptionEditorDialog,
        EditCategoryDialogComponent,
        ConfirmationDialogComponent,
        ErrorDialogComponent,
        ContentPageListComponent,
        CreateContentPageComponent,
        SafeHtmlPipeImages,
        SafeHtmlAllowUrlPipe,
        SettingsEditDialogComponent,
        ListSpotLightsComponent,
        CreateSpotLightComponent,
        CreateContentBoxComponent,
        ContentBoxListComponent,
        DecimalNumber,
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        CartModule,
        AnalyticsModule,
        ProductsModule,
        CommonModule,
        StoreModule.forRoot([]),
        StoreModule.forFeature(fromAppState.appStateFeatureKey, fromAppState.reducer),
        StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
            logOnly: environment.production, // Restrict extension to log-only mode
        }),
        EffectsModule.forRoot([]),
        HttpClientModule,
        AppRoutingModule,
        SharedModule,
        DgoodsSharedModule,
        ModesoCoreModule,
        FormsModule,
        ReactiveFormsModule,
        AdminModule.forRoot(adminConfig),
        TwintCouponModule.forRoot(couponConfig),
        DgoodsUserModule.forRoot(userConfig),
        BrowserAnimationsModule,
        DragDropModule,
        MatDialogModule,
        MatSelectModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        NgxMaterialTimepickerModule,
        MatTableModule,
        MatPaginatorModule,
        MatListModule,
        MatSnackBarModule,
        MatCheckboxModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        AngularEditorModule,
        MatTableExporterModule,
        MatRadioModule,
        NgxMatNativeDateModule,
        NgxMatDatetimePickerModule,
        MatMomentDateModule,
        NgxMatMomentModule,
        MatIconModule,
        MatSortModule,
        MatSlideToggleModule,
        MatButtonModule,
        MatMenuModule,
        NgxFileDropModule,
        MatTooltipModule,
    ],
    entryComponents: [
        PopUpComponent,
        UpdateDefaultDialog,
        AddOrUpdateIssuerDialog,
        UpdateLocalizationByKeyDialog,
        UpdateContentByProductLineDialog,
        UpdateUserByIdDialog,
    ],
    providers: [
        AuthGuard,
        GetEnumKeyFromValuePipe,
        PascalCasePipe,
        SafeHtmlPipe,
        MarkdownPipe,
        SafeHtmlPipeImages,
        SafeHtmlAllowUrlPipe,
        { provide: AUTH_INTERCEPTOR, useClass: SessionOrchestrator },
        { provide: HTTP_INTERCEPTORS, useClass: AuthHandler, multi: true },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
